import { useCallback, useState } from "react";

const useDownloadPDFFromURL = () => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const downloadFile = useCallback(async (url: string, fileName: string) => {
        // Prevent concurrent downloads of the same file
        if (isDownloading) return;

        setIsDownloading(true);
        setError(null);

        try {
            const response = await fetch(url);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch file: ${response.statusText}`);
            }

            const blob = await response.blob();
            const objectUrl = window.URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = objectUrl;
            link.setAttribute('download', fileName);
            
            document.body.appendChild(link);
            link.click();
            
            // Clean up DOM and Memory
            if (link.parentNode) {
                link.parentNode.removeChild(link);
            }
            window.URL.revokeObjectURL(objectUrl);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
            setError(errorMessage);
            console.error("Download Error:", errorMessage);
        } finally {
            setIsDownloading(false);
        }
    }, [isDownloading]); // Dependency on isDownloading prevents double-clicks

    return { downloadFile, loading: isDownloading, error };
};

export default useDownloadPDFFromURL;